import info from './info/it';

const it = {
  meta: {
    homeTitle: 'Blissful Play — La collezione Bears | Caramelle intime per coppie',
    homeDescription: 'Scopri i Bears: caramelle gommose, cioccolato e miele intimi di qualità per coppie. Imballaggio discreto, spedizione rapida in UE. Solo 18+.',
    shopTitle: 'Tutti i prodotti — Blissful Play',
    categoryTitle: '{{name}} — Blissful Play',
    categoryDescription: '{{name}} su Blissful Play: prodotti intimi di qualità per coppie, imballaggio discreto, spedizione rapida in UE. Solo 18+.',
    productTitle: '{{name}} — Blissful Play',
    infoTitle: '{{name}} — Blissful Play',
  },
  lang: {
    label: 'Lingua',
    short: { en: 'EN', ru: 'RU', it: 'IT' },
    name: { en: 'English', ru: 'Русский', it: 'Italiano' },
  },
  nav: {
    strip: 'Imballaggio discreto gratuito su ogni ordine · Spedizione rapida in UE · Solo 18+',
    bears: 'Bears ✦ I più venduti',
    shopAll: 'Tutti i prodotti',
    how: 'Come funziona',
    faq: 'FAQ',
    cart: 'Carrello',
    categories: 'Categorie',
    openMenu: 'Apri il menu',
    closeMenu: 'Chiudi il menu',
  },
  age: {
    badgeAdults: 'Solo 18+',
    badgeDiscreet: 'Discreto',
    title: 'Hai almeno 18 anni?',
    text: 'Devi essere maggiorenne per entrare in questo sito.',
    enter: 'Sì, entra',
    leave: 'No, esci',
  },
  hero: {
    badgeLimited: 'Edizione limitata',
    badgeVegan: 'Caramelle vegane',
    badgeCouples: 'Pensato per le coppie',
    titleStart: 'Rendi le tue notti',
    titleAccent: 'più dolci',
  },
  bears: {
    title: 'La collezione Bears',
    perkShipping: 'Spedizione express',
    perkPackaging: 'Imballaggio neutro',
    perkIngredients: 'Ingredienti di qualità',
    prev: 'Prodotti precedenti',
    next: 'Prodotti successivi',
  },
  showcase: {
    title: 'Perché le coppie scelgono i Bears',
    subtitle: 'Estratti naturali, un formato dolce e massima discrezione.',
    open: 'Apri a grandezza piena',
    alt: {
      couple: 'Caramelle gommose Boner Bears per lui e Bliss Bears per lei accanto a una coppia sorridente',
      ingredients: 'Ingredienti: estratto di melograno, artiglio del gatto, ashwagandha e tongkat ali, epimedium (horny goat weed), L-arginina',
      chocolateHoney: 'Cioccolato e miele Boner Bears in bustine monodose — semplici, pratici e discreti',
      benefits: 'Vantaggi principali: piacere intenso, formula rapida, ingredienti sicuri, pratico e discreto',
      confidence: 'Una coppia con le confezioni di caramelle Boner Bears e Bliss Bears',
    },
  },
  categories: {
    title: 'Esplora la collezione',
    subtitle: 'Selezioni curate per ogni tipo di piacere.',
    count_one: '{{count}} prodotto',
    count_other: '{{count}} prodotti',
  },
  categoryNames: {
    vibrators: 'Vibratori',
    'cock-rings': 'Anelli fallici',
    'enhancement-gummies': 'Caramelle stimolanti',
    'honey-chocolate': 'Miele e cioccolato',
    'adult-toys': 'Giocattoli per adulti',
  },
  how: {
    title: 'Semplice. Discreto. Efficace.',
    steps: [
      { title: 'Scegli la tua confezione', description: 'Sfoglia la nostra selezione di prodotti intimi di qualità.' },
      { title: 'Goditi il momento', description: "Condividi l'esperienza con il tuo partner." },
      { title: 'Senti la scintilla', description: 'Lascia che la magia accada in modo naturale.' },
    ],
  },
  reviews: {
    title: 'Le coppie adorano i Bears',
    stars: '5 stelle su 5',
    items: [
      { name: 'Sarah M.', text: 'Incredibili! Io e il mio partner abbiamo passato una serata fantastica. La qualità è eccellente e gli effetti sono esattamente come descritti. Consigliatissimi!' },
      { name: 'James R.', text: "Imballaggio discreto perfetto. Il prodotto ha superato le nostre aspettative. Ordineremo sicuramente di nuovo!" },
      { name: 'Emily K.', text: "Per noi ha cambiato tutto. Il gusto è ottimo e l'esperienza indimenticabile. Cinque stelle senza dubbio!" },
    ],
  },
  privacy: {
    title: 'La tua privacy, la nostra priorità',
    text: "Scatole anonime senza alcuna indicazione del contenuto. Un nome aziendale discreto sull'estratto conto. Non condividiamo mai i tuoi dati.",
    packaging: 'Imballaggio neutro',
    billing: 'Fatturazione riservata',
  },
  faq: {
    title: 'Domande?',
    items: [
      { question: 'I prodotti sono solo per maggiorenni?', answer: "Sì. I prodotti Blissful Play sono destinati esclusivamente agli adulti dai 18 anni in su. Verifichiamo l'età all'ingresso del sito." },
      { question: 'La spedizione è davvero discreta?', answer: "Sì! Tutti gli ordini vengono spediti in un imballaggio anonimo, senza alcuna indicazione del contenuto. Sull'estratto conto comparirà un nome aziendale discreto." },
      { question: 'Quanto tempo richiede la consegna?', answer: "Tutti gli ordini viaggiano con spedizione express. Di solito arrivano in 3–5 giorni lavorativi. Al checkout puoi scegliere anche la consegna urgente." },
      { question: 'Questi prodotti sono sicuri?', answer: 'Assolutamente. Tutti i prodotti Blissful Play sono realizzati con ingredienti di qualità, accuratamente selezionati. Ogni lotto viene controllato per qualità e sicurezza.' },
      { question: 'E se ho altre domande?', answer: 'Contatta il nostro servizio clienti: siamo qui per aiutarti con qualsiasi domanda o dubbio.' },
    ],
  },
  shop: {
    title: 'Tutti i prodotti',
    subtitle: 'Scopri la nostra collezione',
    all: 'Tutti',
    productsCount_one: '{{count}} prodotto',
    productsCount_other: '{{count}} prodotti',
    empty: 'Ancora nessun prodotto in questa categoria.',
    viewAll: 'Vedi tutti i prodotti',
    loading: 'Caricamento prodotti…',
    loadFailed: 'Impossibile caricare i prodotti',
  },
  product: {
    addToCart: 'Aggiungi',
    added: 'Aggiunto',
    addedLive: '{{name}} aggiunto al carrello',
    soldOut: 'Esaurito',
    limited: 'Limited',
  },
  pdp: {
    back: 'Torna al negozio',
    loading: 'Caricamento prodotto…',
    notFound: 'Prodotto non trovato',
    loadFailed: 'Impossibile caricare il prodotto',
    view: 'vista {{n}}',
    fastDelivery: 'Spedizione rapida',
    fastDeliveryNote: 'UE 5–12 giorni',
    discreet: 'Discreto',
    plainPackaging: 'Imballaggio anonimo',
    size: 'Variante',
    variantSoldOut: '{{size}} esaurito. Scegli un’altra variante o torna a trovarci presto.',
    variantLowStock: 'Solo {{count}} rimasti per {{size}}: ordina presto',
    variantSoldOutToast: 'Spiacenti, questa variante è esaurita',
    details: 'Dettagli del prodotto',
    category: 'Categoria',
    stock: 'Disponibilità',
    inStock: 'Disponibile',
    onlyLeft: 'Solo {{count}} rimasti',
    delivery: 'Consegna',
    adultsOnly: 'Solo per adulti',
    adultsOnlyText: 'Destinato ad adulti dai 18 anni in su. Tenere fuori dalla portata dei bambini.',
    addToCartPrice: 'Aggiungi al carrello — {{price}}',
    secureCheckout: 'Pagamento sicuro',
    privateShipping: 'Spedizione riservata',
  },
  cart: {
    title: 'Il tuo carrello',
    empty: 'Il carrello è vuoto',
    total: 'Totale',
    checkout: 'Vai alla cassa',
    continue: 'Continua lo shopping',
    close: 'Chiudi il carrello',
    size: 'Variante',
    increase: 'Aumenta la quantità',
    decrease: 'Diminuisci la quantità',
    remove: 'Rimuovi',
    removed: 'Rimosso dal carrello',
  },
  checkout: {
    stepShipping: 'Spedizione',
    stepPayment: 'Pagamento',
    shippingTitle: 'Dati di spedizione',
    shippingSubtitle: 'Inserisci i dati per la spedizione',
    firstName: 'Nome',
    lastName: 'Cognome',
    email: 'Email',
    phone: 'Telefono',
    street: 'Indirizzo',
    apartment: 'Interno / scala',
    optional: '(facoltativo)',
    city: 'Città',
    postalCode: 'CAP',
    country: 'Paese',
    required: 'Il campo «{{field}}» è obbligatorio',
    emailInvalid: 'Email non valida',
    fillRequired: 'Compila tutti i campi obbligatori',
    discreetTitle: 'Spedizione discreta. Nessun logo sulla confezione.',
    discreetText: 'Il pacco arriverà in un imballaggio anonimo, senza alcuna indicazione del contenuto.',
    continueToPayment: 'Continua al pagamento',
    reviewTitle: 'Riepilogo e pagamento',
    reviewSubtitle: "Controlla i dettagli dell'ordine",
    shippingAddress: 'Indirizzo di spedizione',
    edit: 'Modifica',
    paymentMethod: 'Metodo di pagamento',
    stripeRedirect: "Verrai reindirizzato alla pagina di pagamento sicura di Stripe per completare l'acquisto.",
    securedByStripe: 'Pagamento sicuro con Stripe',
    processing: 'Elaborazione…',
    pay: 'Paga {{price}}',
    sessionFailed: 'Impossibile avviare il pagamento',
    cartEmpty: 'Il carrello è vuoto',
    continueShopping: 'Continua lo shopping',
    orderSummary: "Riepilogo dell'ordine",
    qty: 'Qtà: {{count}}',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    free: 'GRATIS',
    total: 'Totale',
  },
  success: {
    confirming: 'Stiamo confermando il pagamento…',
    title: 'Ordine confermato!',
    text: 'Grazie per il tuo acquisto. Abbiamo ricevuto il tuo ordine e lo spediremo in modo discreto.',
    orderNumber: 'Numero ordine:',
    emailTitle: 'Email di conferma inviata',
    emailText: "Abbiamo inviato un'email di conferma a <1>{{email}}</1> con i dettagli dell'ordine e le informazioni di tracciamento.",
    shippingAddress: 'Indirizzo di spedizione',
    estimatedDelivery: 'Consegna prevista',
    deliveryText: 'Il tuo ordine verrà spedito entro 24 ore e di solito arriva in 3–5 giorni lavorativi.',
    discreetTitle: 'Spedizione discreta. Nessun logo sulla confezione.',
    discreetText: "Il pacco arriverà in un imballaggio anonimo, senza alcuna indicazione del contenuto. Sull'estratto conto comparirà un nome aziendale discreto. La tua privacy è la nostra priorità.",
    orderSummary: "Riepilogo dell'ordine",
    totalPaid: 'Totale pagato',
    continueShopping: 'Continua lo shopping',
    backHome: 'Torna alla home',
    help: 'Serve aiuto? Scrivici a',
    statusTitle: 'Stato del pagamento',
    statusError: 'Errore durante la verifica del pagamento',
    statusTimeout: 'La verifica del pagamento è scaduta',
    backToShop: 'Torna al negozio',
  },
  cancel: {
    title: 'Pagamento annullato',
    text: 'Il pagamento è stato annullato. Non è stato addebitato nulla.',
    retry: 'Riprova',
    continueShopping: 'Continua lo shopping',
  },
  popup: {
    badge: 'Solo per iscritti',
    titleStart: 'Ottieni il',
    titleAccent: '10%',
    titleEnd: 'di sconto',
    text: 'Iscriviti alla nostra lista per ricevere offerte esclusive.',
    emailLabel: 'Email',
    placeholder: 'La tua email',
    subscribe: 'Iscriviti',
    subscribing: 'Iscrizione…',
    legal: "Iscrivendoti accetti di ricevere email promozionali. Puoi annullare l'iscrizione in qualsiasi momento.",
    close: 'Chiudi',
    noThanks: 'No, grazie',
    success: 'Iscrizione completata!',
    error: 'Iscrizione non riuscita. Riprova.',
  },
  footer: {
    tagline: 'Prodotti intimi di qualità pensati per le coppie. Consegna discreta. Cura in ogni dettaglio.',
    shop: 'Negozio',
    allProducts: 'Tutti i prodotti',
    bundles: 'Bundle',
    information: 'Informazioni',
    adults: 'Solo per maggiorenni.',
    cookies: 'Impostazioni cookie',
  },
  cookies: {
    title: 'Cookie, con discrezione',
    text: 'Usiamo solo ciò che serve al funzionamento del negozio (carrello, verifica età, lingua). Con il tuo consenso usiamo anche cookie di analisi e marketing per migliorare il sito.',
    onlyNecessary: 'Solo necessari',
    acceptAll: 'Accetta tutti',
    customize: 'Personalizza',
    save: 'Salva le scelte',
    necessary: 'Strettamente necessari',
    necessaryDesc: 'Carrello, conferma età e lingua. Sempre attivi.',
    analytics: 'Analisi',
    analyticsDesc: 'Statistiche anonime che ci aiutano a migliorare il negozio.',
    marketing: 'Marketing',
    marketingDesc: 'Misurare gli annunci e mostrare offerte pertinenti.',
  },
  info,
};

export default it;
